import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=4e15a8a6&scoped=true&lang=pug"
import script from "./Weekly.vue?vue&type=script&lang=js"
export * from "./Weekly.vue?vue&type=script&lang=js"
import style0 from "./Weekly.vue?vue&type=style&index=0&id=4e15a8a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15a8a6",
  null
  
)

export default component.exports